import { PaymentDeliveryMethodType } from '@routable/shared';
import React from 'react';
import { AddBankAccountManuallyButton } from 'modules/fundingAccount';
import { GetPaidViaPayPal } from '../../../../../GetPaidViaPayPal';
export const AddInternationalFundingAccountOptions = ({ fundingRoutes }) => {
    const acceptInternationalBank = fundingRoutes.some((route) => route.deliveryMethod === PaymentDeliveryMethodType.INTERNATIONAL);
    const acceptPaypal = fundingRoutes.some((route) => route.deliveryMethod === PaymentDeliveryMethodType.PAYPAL);
    return (React.createElement("div", { className: "flex flex-col gap-3" },
        acceptInternationalBank && React.createElement(AddBankAccountManuallyButton, null),
        acceptPaypal && React.createElement(GetPaidViaPayPal, null)));
};
